import { TaxData } from '../../data-types/taxes/taxesInterfaces';
import { store } from '../../state/store';

export const getNetStake = (taxData: TaxData, applyMultiplier = true) => {
  const {
    customization: { internationalSettings },
  } = store.getState();
  const { countrySettingsByLocation } = internationalSettings;
  const { stake, placeOdds } = taxData;
  const multiplier = placeOdds && applyMultiplier ? 2 : 1;

  return multiplier * (countrySettingsByLocation ? stake / (1 + countrySettingsByLocation.taxRateTicketStake / 100) : stake);
};
